import { QUERY_KEY } from '@constants/queries';
import { useInfiniteQuery } from '@tanstack/react-query';
import { GET } from '@lib/axios';
import { ApiListResponse, PublicPodcast } from '@utils/typesPages/types';
import { FETCH_LIMIT_PODCASTS } from '@constants/pagination';

export const fetchInfinitePodcasts = async ({
  pageParam,
}: {
  pageParam: number;
}) => {
  const params: { limit: number; page: number; category?: string } = {
    limit: FETCH_LIMIT_PODCASTS,
    page: pageParam,
  };

  const { data } = await GET<ApiListResponse<PublicPodcast[]>>(
    '/api/podcasts',
    {
      params: params,
    }
  );

  return data;
};

export const useFetchInfinitePodcasts = () => {
  return useInfiniteQuery({
    queryKey: [QUERY_KEY.FETCH_PODCASTS],
    initialPageParam: 1,
    queryFn: ({ pageParam }) => fetchInfinitePodcasts({ pageParam }),
    getNextPageParam: (lastPage) => {
      return lastPage.meta.total_pages === lastPage.meta.current_page
        ? undefined
        : lastPage.meta.current_page + 1;
    },
    refetchInterval: 300000,
    gcTime: 300000,
    refetchOnWindowFocus: true,
  });
};
